import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NodeItem, TreeOptionsType } from './ReactreeUtils.js';
import ReactreeRootNode from './ReactreeRootNode';
import ReactreeDropdown from './ReactreeDropdown'

const DEFAULT_NEW_ID_PREFIX = 'newnode';

class Reactree extends Component {
	constructor(props) {
		super(props);

		this.handleOutsideClick = this.handleOutsideClick.bind(this);
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.onNodeClick = this.onNodeClick.bind(this);
		this.hideDropdown = this.hideDropdown.bind(this);
		this.onBeforeAdd = this.onBeforeAdd.bind(this);
		this.onAfterAdd = this.onAfterAdd.bind(this);
		this.onBeforeRename = this.onBeforeRename.bind(this);
		this.onAfterRename = this.onAfterRename.bind(this);
		this.onBeforeRemove = this.onBeforeRemove.bind(this);
		this.onAfterRemove = this.onAfterRemove.bind(this);
		this.onBeforeMove = this.onBeforeMove.bind(this);
		this.onAfterMove = this.onAfterMove.bind(this);

		this.window = this.props.window || window;

		this.state = {
			nodes: this.props.nodes,
			nodeJson: JSON.stringify(NodeItem.parseList(this.props.nodes)),
			dropdownOptions: this.getDefaultDropdownOptions(),
			activeNodeId: this.props.options.activeRootOnInit ? undefined : null
		};
	}

	componentWillMount() {
		this.window.addEventListener('click', this.handleOutsideClick);
		this.window.addEventListener('resize', this.hideDropdown);
		this.window.addEventListener('scroll', this.hideDropdown);
	}

	componentWillUnmount() {
		this.window.removeEventListener('click', this.handleOutsideClick);
		this.window.removeEventListener('resize', this.hideDropdown);
		this.window.removeEventListener('scroll', this.hideDropdown);
	}

	componentWillReceiveProps(nextProps) {
		const nextNodesJson = JSON.stringify(NodeItem.parseList(nextProps.nodes));
		if (nextNodesJson !== this.state.nodeJson) {
			this.setState({
				nodeJson: nextNodesJson
			});
		}
	}

	componentWillUpdate(nextProps, nextState){
    // perform any preparations for an upcoming update
    	nextState.nodeJson = JSON.stringify(NodeItem.parseList(nextState.nodes))
    	this.props = nextProps;
    	this.state = nextState;
	}

	getChildContext() {
		return {
			toggleDropdown: this.toggleDropdown,
			onNodeClick: this.onNodeClick
		};
	}

	handleOutsideClick(event) {
		this.hideDropdown();
	}

	getDefaultDropdownOptions() {
		return {
			targetElement: null,
			targetNodeId: null,
			onAddClick: null,
			onRenameClick: null,
			onRemoveClick: null
		};
	}

	toggleDropdown(dropdownOptions) {
		if (dropdownOptions.targetNodeId !== this.state.dropdownOptions.targetNodeId) {
			this.setState({ dropdownOptions });
		} else {
			this.hideDropdown();
		}
	}

	onNodeClick(node) {
		this.setState({
			activeNodeId: node.id
		});

		if (typeof this.props.onNodeClick === 'function') {
			this.props.onNodeClick(JSON.parse(JSON.stringify(node)));
			return true;
		}
		return false;
	}

	hideDropdown() {
		if (!!this.state.dropdownOptions.targetElement) {
			this.setState({ dropdownOptions: this.getDefaultDropdownOptions() });
		}
	}

	onBeforeAdd(node) {
		if (typeof this.props.onAfterAdd === 'function') {
			return this.props.onBeforeAdd(JSON.parse(JSON.stringify(node)));
		}
		return true;
	}

	onAfterAdd(node, onAddSuccess) {
		if (typeof this.props.onAfterAdd === 'function') {
			this.props.onAfterAdd(JSON.parse(JSON.stringify(node)), onAddSuccess);
		}
	}

	onBeforeRename(node) {
		if (typeof this.props.onAfterRename === 'function') {
			return this.props.onBeforeRename(JSON.parse(JSON.stringify(node)));
		}
		return true;
	}

	onAfterRename(node) {
		if (typeof this.props.onAfterRename === 'function') {
			this.props.onAfterRename(JSON.parse(JSON.stringify(node)));
		}
	}

	onBeforeRemove(node) {
		if (typeof this.props.onAfterRemove === 'function') {
			return this.props.onBeforeRemove(JSON.parse(JSON.stringify(node)));
		}
		return true;
	}

	onAfterRemove(node) {
		if (typeof this.props.onAfterRemove === 'function') {
			this.props.onAfterRemove(JSON.parse(JSON.stringify(node)));
		}
	}

	onBeforeMove(node) {
		if (typeof this.props.onAfterMove === 'function') {
			return this.props.onBeforeMove(JSON.parse(JSON.stringify(node)));
		}
		return true;
	}

	onAfterMove(node) {
		if (typeof this.props.onAfterMove === 'function') {
			this.props.onAfterMove(JSON.parse(JSON.stringify(node)));
		}
	}

	render() {
		return (
			<div className="reactree">
				<ReactreeDropdown dropdownOptions={this.state.dropdownOptions} />
				<ReactreeRootNode
					nodeJson={this.state.nodeJson}
					activeNodeId={this.state.activeNodeId}
					onAfterAdd={this.onAfterAdd}
					onBeforeAdd={this.onBeforeAdd}
					onAfterRename={this.onAfterRename}
					onBeforeRename={this.onBeforeRename}
					onAfterRemove={this.onAfterRemove}
					onBeforeRemove={this.onBeforeRemove}
					onAfterMove={this.onAfterMove}
					onBeforeMove={this.onBeforeMove}
					options={this.props.options}
				/>
			</div>
		);
	}
}

Reactree.childContextTypes = {
	toggleDropdown: PropTypes.func,
	onNodeClick: PropTypes.func
};

Reactree.propTypes = {
	nodes: PropTypes.array.isRequired,
	onAfterAdd: PropTypes.func,
	onBeforeAdd: PropTypes.func,
	onAfterRename: PropTypes.func,
	onBeforeRename: PropTypes.func,
	onAfterRemove: PropTypes.func,
	onBeforeRemove: PropTypes.func,
	onAfterMove: PropTypes.func,
	onBeforeMove: PropTypes.func,
	onNodeClick: PropTypes.func,
	options: TreeOptionsType,
	window: PropTypes.object
};

Reactree.defaultProps = {
	options: {
		rootName: '루트',
		activeRootOnInit: false,
		activeNodeOnClick: false,
		expandRootOnInit: false,
		orderPredicate: undefined,
		disableDropdown: false,
		disableDrag: false,
		disableDrop: false
	}
};

export default Reactree;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/ui/Reactree/index.jsx